var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.appType)?_c('FormSelect',{attrs:{"id":"selectRegion","name":"selectRegion","string-selector":"regions","options":_vm.regionList,"label-text":""},on:{"change":function($event){return _vm.changeRegion($event)}},model:{value:(_vm.selectedRegion),callback:function ($$v) {_vm.selectedRegion=$$v},expression:"selectedRegion"}}):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }